import moment from "moment";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Button,
    Col,
    Collapse,
    Row
} from "reactstrap";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { handleSetSkipGuarantor } from "../../containers/tenant/actions/tenant";
import { handleInitiateCredit } from "../../store/actions/credit";
import { employmentStatus, states, tuRenterTOS } from "../../util/FormConstants";
import { normalizeDate, normalizePhone, normalizeSS } from "../../util/normalizers";
import PolyUtil from "../../util/PolyUtil";
import { CheckBoxField, InputField, SelectField, SSNInputField } from "../../validation/ReduxFormInput";
import { FormAsyncButton } from "../controls/buttons/AsyncButton";
import ReduxModalWrapper from "../display/Modals/ReduxModalWrapper";


class CreditForm extends Component {
    state = {
        changeInformation: false,
    };

    render() {
        const {
            handleSubmit, _handleSubmitCredit, invalid, pristine, submitting,
            form_values: {
                SocialSecurityNumber,
                EmploymentStatus,
                Income
            }
        } = this.props;

        return (
            <div>
                <form onSubmit={handleSubmit(_handleSubmitCredit)}>
                    <Row>
                        <Col xs={12} sm={4}>
                            <Field name="SocialSecurityNumber"
                                   label="Social Security #"
                                   component={SSNInputField}
                                   placeholder="XXX-XX-XXXX"
                                   type="text"
                                   normalize={normalizeSS}
                                   addon={<span className="input-group-text fa fa-lock" />}
                                   addon_end
                            />
                        </Col>
                        <Col xs={12} sm={4}>
                            <Field name="EmploymentStatus" label="Employment Status" component={SelectField} options={employmentStatus}/>
                        </Col>
                        <Col xs={12} sm={4}>
                            <Field name="Income" label="Income" addon="$" placeholder="Annual" component={InputField} type="number"/>
                        </Col>
                    </Row>
                    {
                        !this.state.changeInformation && (
                            <div className="center">
                                <Button type="button"
                                        color="success"
                                        outline
                                        disabled={!SocialSecurityNumber || !EmploymentStatus || !Income}
                                        onClick={() => this.setState({changeInformation: true})}>
                                    Continue
                                </Button>
                            </div>
                        )
                    }

                    <Collapse isOpen={this.state.changeInformation}>
                        <hr/>
                        <h4><strong>Does all of this look correct?</strong></h4>
                        <Row>
                            <Col xs={12} sm={4}><Field name="FirstName" label="First Name" component={InputField} type="text"/></Col>
                            <Col xs={12} sm={4}><Field name="MiddleName" label="Middle Name" component={InputField} type="text"/></Col>
                            <Col xs={12} sm={4}><Field name="LastName" label="Last Name" component={InputField} type="text"/></Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={4}><Field name="HomePhoneNumber" label="Phone Number" component={InputField} normalize={normalizePhone}/></Col>
                            <Col xs={12} sm={4}><Field name="Email" label="Email" component={InputField} type="email"/></Col>
                            <Col xs={12} sm={4}><Field name="DateOfBirth" label="Date of Birth" placeholder="MM/DD/YYYY"  component={InputField} type="text" normalize={normalizeDate}/></Col>
                        </Row>
                        <hr/>
                        <Row>
                            <Col xs={12} sm={8}>
                                <Field name="StreetAddressLineOne" label="Address" component={InputField}/>
                            </Col>
                            <Col xs={12} sm={4}>
                                <Field name="StreetAddressLineTwo" label="Apt/Unit" component={InputField}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={4}>
                                <Field name="City" label="City" component={InputField}/>
                            </Col>
                            <Col xs={12} sm={4}>
                                <Field name="State" label="State" component={SelectField} options={states}/>
                            </Col>
                            <Col xs={12} sm={4}>
                                <Field name="Zip" label="Zip Code" component={InputField} type="number"/>
                            </Col>
                        </Row>
                        <hr/>
                        <p><strong>TransUnion Service Agreement</strong></p>
                        <div style={{height: '220px', overflow: 'auto', border: '1px solid #bbbbbb', borderRadius: '4px', padding: '10px'}}>
                            {tuRenterTOS}
                        </div>

                        <Field name="FcraAgreementAccepted" label="I agree to the TransUnion Service Agreement above." component={CheckBoxField}/>
                        <div className="center">
                            <FormAsyncButton type="submit"
                                             color="success"
                                             className="mt-2 mb-2"
                                             outline
                                             disabled={pristine || invalid}
                                             acting={submitting}>
                                Let's Go
                            </FormAsyncButton>
                        </div>
                    </Collapse>
                </form>

                <ReduxModalWrapper id="tu_exam_modal"/>

            </div>
        );
    }
}

CreditForm.propTypes = {
    guarantor: PropTypes.bool,
    tenantId: PropTypes.any,
    tenantKey: PropTypes.any,
};

const validate = values => {
    const errors = {};

    !values.SocialSecurityNumber && (errors.SocialSecurityNumber = 'Required');
    (values.SocialSecurityNumber && values.SocialSecurityNumber.length !== 11) && (errors.SocialSecurityNumber = 'That is not a valid social security number');

    (!values.EmploymentStatus || values.EmploymentStatus === 'default') && (errors.EmploymentStatus = 'Required');
    !values.Income && (errors.Income = 'Required');
    (values.Income && values.Income < 0) && (errors.Income = 'Cannot be less than 0');

    !values.FirstName && (errors.FirstName = 'Required');
    !values.LastName && (errors.LastName = 'Required');
    !values.HomePhoneNumber && (errors.HomePhoneNumber = 'Required');
    (values.HomePhoneNumber && values.HomePhoneNumber.length !== 12) && (errors.HomePhoneNumber = 'Please enter a valid phone number');

    !values.Email && (errors.Email = 'Required');
    !values.FirstName && (errors.FirstName = 'Required');

    !values.DateOfBirth && (errors.DateOfBirth = 'Required');
    !moment(values.DateOfBirth, "MM/DD/YYYY").isValid() && (errors.DateOfBirth = 'Please enter a valid date');

    !values.StreetAddressLineOne && (errors.StreetAddressLineOne = 'Required');
    !values.City && (errors.City = 'Required');
    (!values.State || values.State === 'default') && (errors.State = 'Required');

    !values.Zip && (errors.Zip = 'Required');
    (values.Zip && (values.Zip > 99999 || values.Zip <= 999)) && (errors.Zip = 'Please enter a valid zip code');

    !values.FcraAgreementAccepted && (errors.FcraAgreementAccepted = 'Required');

    return errors;
};

CreditForm = reduxForm({
    form: 'credit_form',
    validate
})(CreditForm);

const mapStateToProps = (state, props) => {
    const selector = formValueSelector('credit_form');
    let initial;
    if (props.guarantor) {
        const guarantor = state.guarantor;
        initial = Object.assign({}, {
            FirstName: guarantor.first_name,
            LastName: guarantor.last_name,
            HomePhoneNumber: guarantor.phone,
            Email: guarantor.email,
            StreetAddressLineOne: PolyUtil.getPropertyStreetAddress(guarantor),
            StreetAddressLineTwo: guarantor.address_identifier,
            City: PolyUtil.getPropertyCity(guarantor),
            State: PolyUtil.getPropertyState(guarantor),
            Zip: PolyUtil.getPropertyZip(guarantor),
        });

        initial.HomePhoneNumber && (initial.HomePhoneNumber = PolyUtil.formatPhone(initial.HomePhoneNumber));
    } else {
        const app = state.tenant.application;
        initial = Object.assign({}, {
            FirstName: app.first_name,
            MiddleName: app.middle_name,
            LastName: app.last_name,
            HomePhoneNumber: app.phone,
            Email: app.email,
            Income: (PolyUtil.validArr(state.tenant.application.employment_history_positions) && state.tenant.application.employment_history_positions[0].gross_income) || ''
        });
        initial.DateOfBirth = moment(app.birth_date, "MM/DD/YYYY").format("MM/DD/YYYY");
        initial.HomePhoneNumber && (initial.HomePhoneNumber = PolyUtil.formatPhone(initial.HomePhoneNumber));

        //Find rental history where the current time is after lease start & before lease end
        let currentResidence = app.rental_history_rentals.find((history) => {
            return moment().isBefore(moment(history.lease_end)) && moment().isAfter(moment(history.lease_start));
        });

        let currentEmployment = app.employment_history_positions.find((history) => {
            return history.end_date === null;
        });

        currentEmployment && (initial.EmploymentStatus = 'Employed');

        if (currentResidence) {
            initial.StreetAddressLineOne = PolyUtil.getPropertyStreetAddress(currentResidence);
            initial.City = PolyUtil.getPropertyCity(currentResidence);
            initial.State = PolyUtil.getPropertyState(currentResidence);
            initial.Zip = PolyUtil.getPropertyZip(currentResidence);
            currentResidence.identifier && (initial.StreetAddressLineTwo = currentResidence.identifier);
        }
    }

    return {
        form_values: selector(state, 'SocialSecurityNumber', 'EmploymentStatus', 'Income'),
        initialValues: initial,
    };
};

const mapDispatchToProps = (dispatch, props) => ({
    _handleSubmitCredit(data) {
        if (props.guarantor) {
            return dispatch(handleInitiateCredit(data, props.tenantId, props.tenantKey));
        } else {
            return dispatch(handleSetSkipGuarantor(true))
                .then(() => {
                    return dispatch(handleInitiateCredit(data));
                });
        }
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditForm);



// WEBPACK FOOTER //
// ./src/components/credit/CreditForm.js